// zoomsize表示变焦范围 传23；point表示圆点数量 传46；initzoom表示初始变焦 传10；factor表示一倍变焦对应多少个圆点 传2；boxsize表示空间大小可传big或者small
//defaultZoomLevel=initzoom*100  /zoomsize
export const zoomConfig = {
    X_45: {
        zoomsize: 45,
        point: 45,
        initzoom: 1,
        factor: 1,
        boxsize: "small",
        defaultZoomLevel: 1
    },
    X_23: {
        zoomsize: 23,
        point: 46,
        initzoom: 1,
        factor: 2,
        boxsize: "small",
        defaultZoomLevel: 1
    },
    X_5: {
        zoomsize: 5,
        point: 40,
        initzoom: 1,
        factor: 10,
        boxsize: "big",
        defaultZoomLevel: 1
    },
    X_4: {
        zoomsize: 4,
        point: 30,
        initzoom: 1,
        factor: 10,
        boxsize: "big",
        defaultZoomLevel: 1
    },
    X_3: {
        zoomsize: 3,
        point: 20,
        initzoom: 1,
        factor: 10,
        boxsize: "big",
        defaultZoomLevel: 1
    },
    X_2: {
        zoomsize: 2,
        point: 40,
        initzoom: 1,
        factor: 40,
        boxsize: "big",
        defaultZoomLevel: 1
    }
}